'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Icon } from '@/ui/icons/icon/Icon'
import { Loader } from '@/ui/loaders/loader/Loader'

const knobVariants = twMerge(
  'absolute left-0 aspect-square h-full scale-[0.75]',
  'grid place-items-center',
  'transform rounded-full bg-white shadow-xs',
  'transition-all duration-[80ms]',
  'group-data-[hovered]/toggle:scale-[0.85]',
  'group-data-[pressed]/toggle:scale-[0.65]',
  'group-data-[selected]/toggle:left-full group-data-[selected]/toggle:-translate-x-full',
  'group-data-[disabled]/toggle:text-brand-2-200',
  'text-brand-2-700',
)

export function Knob({
  isLoading,
  isClickAndCollect,
  isDisabled,
  isSelected,
}: {
  isLoading?: boolean
  isClickAndCollect?: boolean
  isDisabled?: boolean
  isSelected?: boolean
}) {
  return (
    <div
      className={twMerge(
        knobVariants,
        isClickAndCollect &&
          !isDisabled &&
          'group-data-[selected]/toggle:text-[--color-click-and-collect-fg]',
      )}
    >
      {isLoading && !isDisabled ? (
        <Loader />
      ) : isSelected ? (
        <Icon.Check size="sm" />
      ) : (
        <Icon.X size="sm" />
      )}
    </div>
  )
}
